module.exports = __webpack_public_path__ + "img/us1.80b6060b.png";